
import engine from 'store/src/store-engine.js'
import localStorage from 'store/storages/localStorage.js'
import expirePlugin from 'store/plugins/expire.js'

const defaultKey = '__FA_USER__'
const defaultExpire = 60 * 60 * 1000 // 60 minutes
let instance = null
let instanceId = 0
export class LocalStorage {
  constructor (keys = [defaultKey], expire = defaultExpire) {
    if (instance) return instance
    instance = this
    this.instanceId = ++instanceId
    this.keys = keys
    this.expire = expire
    const storages = [localStorage]
    const plugins = [expirePlugin]
    this.store = engine.createStore(storages, plugins)

    // init canvas for saving image base64string
    this.canvas = document.createElement('canvas')
    this.ctx2d = this.canvas.getContext('2d')

    return this
  }

  _checkIsInKeys (key) {
    if (this.keys.indexOf(key) === -1) {
      console.error('The key is not in the keys array, if you want to use it, just adding it when constructing')
      return false
    }
    return true
  }

  addKeys (keys = []) {
    if (!Array.isArray(keys)) {
      return new Error('Keys needed to be an array.')
    }
    this.keys = Array.prototype.concat.call(this.keys, keys)
  }

  get (key) {
    if (!this._checkIsInKeys(key)) return
    if (!this.isExpired(key)) {
      return this.store.get(key)
    }
    return null
  }

  set (key, value, expire = defaultExpire + Date.now()) {
    if (!this._checkIsInKeys(key)) return
    this.store.set(key, value, expire)
  }

  isExpired (key) {
    if (!this._checkIsInKeys(key)) return
    return this.store.getExpiration(key) <= Date.now()
  }

  remove (key) {
    if (!this._checkIsInKeys(key)) return
    this.store.remove(key)
  }

  clearAllExpired () {
    this.store.removeExpiredKeys()
  }

  getUser () {
    if (!this.isUserExpired()) {
      return this.get(defaultKey)
    } else {
      this.remove(defaultKey)
      return null
    }
  }

  setUser (value) {
    let expiredAt = null
    if (value && value.token && value.expired) {
      expiredAt = value.expired * 1000
    } else {
      expiredAt = Date.now() + this.expire
    }
    this.set(defaultKey, value, expiredAt)
  }

  isUserExpired () {
    return this.store.getExpiration(this.defaultKey) <= Date.now()
  }

  getImage (name) {
    if (this.isExpired(name)) {
      this.clearExpired(name)
      return null
    }
    return this.get(name)
  }

  saveImage (name, imageSrc, expire = defaultExpire) {
    // clear before drawing new image into canvas
    this.ctx2d.save()
    this.ctx2d.setTransform(1, 0, 0, 1, 0, 0)
    this.ctx2d.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.ctx2d.restore()

    const image = new Image()
    image.addEventListener('load', (e) => {
      this.canvas.width = image.width
      this.canvas.height = image.height
      this.ctx2d.drawImage(image, 0, 0)
      const imageSrcArray = imageSrc.split('.')
      const imageExt = imageSrcArray[imageSrcArray.length - 1]
      const base64string = this.canvas.toDataURL(`image/${imageExt}`)
      this.set(name, base64string, Date.now() + expire)
    })
    image.src = imageSrc
  }
}

export const VueLocalStorage = {}
VueLocalStorage.install = function (Vue, options) {
  let ls = null
  if (!options) {
    ls = new LocalStorage()
  } else {
    const keys = options.keys
    const expire = options.expire
    ls = new LocalStorage(keys, expire)
  }
  ls.addKeys(['MEMBER_CUR_STORE'])
  // Global
  Vue.localStorage = ls

  // VM instance
  Vue.prototype.$localStorage = ls
}



// WEBPACK FOOTER //
// ./src/common/js/LocalStorage.js